<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "MessageSetting"
}
</script>

<style scoped>

</style>